(function () {
    'use strict';

    angular
        .module('app.directive')
        .directive('repeatEnd', repeatEnd);
    function repeatEnd() {
        // Usage:
        //      EventCaller When ng-repeat Over
        // Creates:
        //      Rhino,2017.01.04
        var directive = {
            restrict: "A",
            link: link,
        };
        return directive;

        function link(scope, element, attrs) {
            if (scope.$last) {
                scope.$eval(attrs.repeatEnd);
            }
        }
    }
})();